import type {
  ArubaNewCentralApiSettings,
  PublicArubaNewCentralApiSettings,
} from './arubaNewCentral';
import type { AwsApiSettings, PublicAwsApiSettings } from './aws';
import type { AzureApiSettings, PublicAzureApiSettings } from './azure';
import type {
  CheckPointApiSettings,
  PublicCheckPointApiSettings,
} from './checkPoint';
import type {
  CiscoApicApiSettings,
  PublicCiscoApicApiSettings,
} from './ciscoApic';
import type {
  CiscoFmcApiSettings,
  PublicCiscoFmcApiSettings,
} from './ciscoFmc';
import type {
  F5osAApiSettings,
  F5osCApiSettings,
  PublicF5osAApiSettings,
  PublicF5osCApiSettings,
} from './f5os';
import type {
  ForcePointApiSettings,
  PublicForcePointApiSettings,
} from './forcePoint';
import type { GcpApiSettings, PublicGcpApiSettings } from './gcp';
import type {
  JuniperMistApiSettings,
  PublicJuniperMistApiSettings,
} from './juniperMist';
import type { MerakiApiSettings, PublicMerakiApiSettings } from './meraki';
import type { NsxTApiSettings, PublicNsxTApiSettings } from './nsxT';
import type { PrismaApiSettings, PublicPrismaApiSettings } from './prisma';
import type {
  PublicRuckusVszApiSettings,
  RuckusVszApiSettings,
} from './ruckusVsz';
import type {
  PublicSilverPeakApiSettings,
  SilverPeakApiSettings,
} from './silverPeak';
import type {
  PublicVeloCloudApiSettings,
  VeloCloudApiSettings,
} from './veloCloud';
import type { PublicVersaApiSettings, VersaApiSettings } from './versa';
import type { PublicViptelaApiSettings, ViptelaApiSettings } from './viptela';

export type VendorApi =
  | ArubaNewCentralApiSettings
  | AwsApiSettings
  | AzureApiSettings
  | CheckPointApiSettings
  | CiscoApicApiSettings
  | CiscoFmcApiSettings
  | F5osAApiSettings
  | F5osCApiSettings
  | ForcePointApiSettings
  | GcpApiSettings
  | JuniperMistApiSettings
  | MerakiApiSettings
  | NsxTApiSettings
  | PrismaApiSettings
  | RuckusVszApiSettings
  | SilverPeakApiSettings
  | VeloCloudApiSettings
  | VersaApiSettings
  | ViptelaApiSettings;

export type PublicVendorApi =
  | PublicArubaNewCentralApiSettings
  | PublicAwsApiSettings
  | PublicAzureApiSettings
  | PublicCheckPointApiSettings
  | PublicCiscoApicApiSettings
  | PublicCiscoFmcApiSettings
  | PublicF5osAApiSettings
  | PublicF5osCApiSettings
  | PublicForcePointApiSettings
  | PublicGcpApiSettings
  | PublicJuniperMistApiSettings
  | PublicMerakiApiSettings
  | PublicNsxTApiSettings
  | PublicPrismaApiSettings
  | PublicRuckusVszApiSettings
  | PublicSilverPeakApiSettings
  | PublicVeloCloudApiSettings
  | PublicVersaApiSettings
  | PublicViptelaApiSettings;
